export const HOURS_OPTIONS = new Array(24)
  .fill(0)
  .map((_, i) => ((i + 8) % 24).toString().padStart(2, "0"))
  .map((hour) => ["00", "15", "30", "45"].map((minute) => `${hour}:${minute}`))
  .flat();
